import script from "./ViewActionSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewActionSettings.vue?vue&type=script&setup=true&lang=js"

import "./ViewActionSettings.vue?vue&type=style&index=0&id=3d46356e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d46356e"]])

export default __exports__